import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledSmall1 = makeDefaultTypographyStyled(
  'Small1',
  'small',
  0.83,
  1.2,
);
